import { useCallback, useEffect, useState } from 'react';
import { SITE } from '../../config/site';
import { SEO_PAGES } from '../../config/seo';
import { Breadcrumbs } from '../../components/ui/Breadcrumbs';
import { Seo } from '../../components/seo';
import { buildBreadcrumbJsonLd } from '../../seo/buildBreadcrumbJsonLd';
import styles from './StudioPage.module.css';

const GALLERY = [
  { src: '/studio/studio-1.jpg', alt: 'Студия NextCake — общий вид' },
  { src: '/studio/studio-2.jpg', alt: 'Студия NextCake — интерьер' },
  { src: '/studio/studio-3.jpg', alt: 'Студия NextCake — рабочая зона' },
  { src: '/studio/studio-4.jpg', alt: 'Студия NextCake — кухонная зона' },
  { src: '/studio/studio-5.jpg', alt: 'Студия NextCake — входная зона' },
  { src: '/studio/studio-6.jpg', alt: 'Студия NextCake — пространство для мероприятий' },
];

const BOOKING_PHONE = '79610816005';
const BOOKING_PHONE_DISPLAY = '+7 961 081-60-05';

export function StudioPage() {
  const [active, setActive] = useState(0);
  const total = GALLERY.length;

  const next = useCallback(() => {
    setActive((i) => (i + 1) % total);
  }, [total]);

  const prev = useCallback(() => {
    setActive((i) => (i - 1 + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const seo = SEO_PAGES.studio;
  const breadcrumbs = [
    { label: 'Главная', to: '/' },
    { label: 'Студия', to: '/studio' },
  ];

  return (
    <div className={`container ${styles.page}`}>
      <Seo
        title={seo.title}
        description={seo.description}
        path={seo.path}
        image="/studio/studio-1.jpg"
        jsonLd={buildBreadcrumbJsonLd(breadcrumbs)}
      />

      <Breadcrumbs items={breadcrumbs} />

      <h1 className={styles.title}>Студия NextCake в {SITE.city}е</h1>

      <div className={styles.body}>
        <div className={styles.content}>
          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>
              Сдаётся студия NextCake рядом с нашим магазином
            </h2>
            <p>
              Светлая студия 35&nbsp;м² с отдельным входом в Дзержинском районе {SITE.city}а (Семь
              Ветров). Современный интерьер, высокие потолки, санузел и просторная входная зона с
              диваном — пространство легко подстраивается под разные форматы.
            </p>
            <p>
              Подходит для кулинарных и творческих мастер-классов, дней рождения, камерных
              праздников, девичников, встреч, лекций и фотосъёмок. Формат — спокойные мероприятия.
              Курение запрещено.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Оснащение</h2>
            <p>
              <strong>Кухонная зона:</strong> гарнитур, духовой шкаф, микроволновка, посудомоечная
              машина, холодильник, морозильная камера, индукционная плита, чайник.
            </p>
            <p>
              <strong>Рабочая зона:</strong> стол-остров 2&nbsp;×&nbsp;1,2&nbsp;м и 10 полубарных
              стульев, дополнительный стол 1,6&nbsp;×&nbsp;0,8&nbsp;м и 8 стульев.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Условия аренды</h2>
            <p>
              Студия работает ежедневно с 10:00 до 22:00. Минимальная аренда — 3 часа, стоимость —
              1&nbsp;000&nbsp;₽/час.
            </p>
            <p>
              Время аренды считается с момента входа организатора до полного освобощения помещения
              и включает подготовку, проведение мероприятия и самостоятельную уборку. По желанию
              доступна услуга уборки после МК — 1&nbsp;000&nbsp;₽.
            </p>
            <p>
              Для бронирования нужна предоплата 2&nbsp;000&nbsp;₽. При отмене менее чем за 7 дней
              предоплата не возвращается. Организатор отвечает за сохранность имущества студии.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Запись</h2>
            <p>
              Для записи и уточнения условий пишите в сообщения MAX или звоните{' '}
              <a href={`tel:+${BOOKING_PHONE}`}>{BOOKING_PHONE_DISPLAY}</a>.
            </p>
          </section>
        </div>

        <section className={styles.slider} aria-label="Фото студии">
          <div className={styles.track}>
            {GALLERY.map((item, index) => (
              <div
                key={item.src}
                className={`${styles.slide} ${index === active ? styles.slideActive : ''}`}
                aria-hidden={index !== active}
              >
                <img src={item.src} alt={item.alt} className={styles.slideImage} />
              </div>
            ))}
          </div>

          <button
            type="button"
            className={`${styles.arrow} ${styles.arrowPrev}`}
            onClick={prev}
            aria-label="Предыдущее фото"
          >
            ‹
          </button>
          <button
            type="button"
            className={`${styles.arrow} ${styles.arrowNext}`}
            onClick={next}
            aria-label="Следующее фото"
          >
            ›
          </button>

          <div className={styles.dots}>
            {GALLERY.map((item, index) => (
              <button
                key={item.src}
                type="button"
                className={`${styles.dot} ${index === active ? styles.dotActive : ''}`}
                onClick={() => setActive(index)}
                aria-label={`Фото ${index + 1}`}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
